import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ClientLogosSection.module.css';
import useScrollAnimation from '../../hooks/useScrollAnimation';

const logoFiles = [
    'deere.png',
    'claas.png',
    'fendt.png',
    'grimme.png',
    'dfhr.webp',
    'dewulf.png',
    'avr.png'
];

const ClientLogosSection = () => {
    const { t } = useTranslation();
    const sectionRef = useScrollAnimation();

    // To make the scroll appear continuous, we can duplicate the logos
    // The number of duplications might need adjustment based on the number of logos and desired smoothness
    const extendedLogoFiles = [...logoFiles, ...logoFiles, ...logoFiles]; 

    return (
        <section className={`${styles.clientLogosSection} animate-on-scroll`} ref={sectionRef}>
            <div className="container">
                <h2 className={`section-title ${styles.sectionTitle}`}>{t('clientLogos.title')}</h2>
                <div className={styles.logosContainer}>
                    <div className={styles.logosTrack}>
                        {extendedLogoFiles.map((logo, index) => (
                            <div className={styles.logoItem} key={`logo-${index}`}>
                                <img 
                                    src={`${process.env.PUBLIC_URL}/images/logos/${logo}`}
                                    alt={logo.split('.')[0]} // Use filename without extension as alt text
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ClientLogosSection; 